import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL } from "../../Consts";
export const getallLang = createAsyncThunk(
  "lang/getAllLang",
  async (_, thunkApi) => {
    const { rejectWithValue, getState } = thunkApi;
    const token = localStorage.getItem("token");
    try {
      const response = await axios.get(`${BASE_URL}/Language`, {
        headers: {
          authorization: `Bearer ${token}`,
        },
      });
      // console.log(response.data);
      return response.data;
    } catch (error) {
      // console.log(error);
      return rejectWithValue(error);
    }
  }
);

export const addLang = createAsyncThunk(
  "lang/addLang",
  async (newData, thunkApi) => {
    const { rejectWithValue, getState } = thunkApi;
    const token = localStorage.getItem("token");
    try {
      const response = await axios.post(`${BASE_URL}/Language/store`, newData, {
        headers: {
          "Content-Type": "application/json,multipart/form-data",
          Accept: "application/json",
          authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
export const updateLang = createAsyncThunk(
  "lang/updateLang",
  async ({ id, newData }, thunkApi) => {
    const { rejectWithValue, getState } = thunkApi;
    const token = localStorage.getItem("token");
    try {
      const response = await axios.post(
        `${BASE_URL}/Language/update/${id}`,
        newData,
        {
          headers: {
            "Content-Type": "application/json,multipart/form-data",
            Accept: "application/json",

            authorization: `Bearer ${token}`,
          },
        }
      );
      // console.log(response);
      return response.data; // Return the response data
    } catch (error) {
      // console.log(error);
      return rejectWithValue(error);
    }
  }
);
export const deleteLang = createAsyncThunk(
  "lang/deleteLang",
  async (id, thunkApi) => {
    const { rejectWithValue, getState } = thunkApi;
    const token = localStorage.getItem("token");
    try {
      const response = await axios.delete(`${BASE_URL}/Language/delete/${id}`, {
        headers: {
          authorization: `Bearer ${token}`,
        },
      });
      // console.log(response);
      return id; // Return the ID of the deleted news item
    } catch (error) {
      // console.log(error);
      return rejectWithValue(error);
    }
  }
);

const langSlice = createSlice({
  name: "news",
  initialState: { lang: [], loading: false, error: null, success: true },
  extraReducers: {
    [getallLang.pending]: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    [getallLang.fulfilled]: (state, action) => {
      state.lang = action.payload;
      state.loading = false;
    },
    [getallLang.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [addLang.pending]: (state, action) => {
      state.loading = true;
      state.error = null;
      state.success = false;
    },
    [addLang.fulfilled]: (state, action) => {
      state.lang = action.payload;
      state.loading = false;
      state.success = true;
    },
    [addLang.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
      state.success = false;
    },
    [updateLang.pending]: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    [updateLang.fulfilled]: (state, action) => {
      const data = state.Lang?.lang?.langs.map((item) =>
        item.id === action.payload.id ? action.payload : item
      );
      state.Lang = data;
      state.loading = false;
    },
    [updateLang.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [deleteLang.pending]: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    [deleteLang.fulfilled]: (state, action) => {
      state.Lang = state.Lang?.lang?.langs?.filter(
        (item) => item.id !== action.payload
      );
      state.loading = false;
    },
    [deleteLang.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});
export default langSlice.reducer;
